export const round = (value: number, fractionDigits = 1, omitZeros = true) => {
  const formatted = value.toFixed(fractionDigits);

  return omitZeros ? formatted.replace(/\.?0+$/, "") : formatted;
};
